<template>
  <v-row v-if="computedClientes.length" style="overflow-x: hidden;" no-gutters>
    <v-col v-if="listStyle === 'list'" cols="12" class="pb-0">
      <v-list
        class="pa-0"
        three-line
        :style="clientesContainer"
      >
        <v-list-item
          v-for="(cliente, i) in computedClientes"
          :key="i"
          class="pt-0"
          @click="$router.push(`/clientes/${cliente.id_interno}`)"
        >
          <v-list-item-content class="pb-0">
            <v-col cols="10" md="4" class="pa-0">
              <v-list-item-title class="body-2 font-weight-bold">
                <v-icon small left>mdi-store</v-icon>
                {{ cliente.nome_fantasia }}
              </v-list-item-title>
            </v-col>
            <v-col cols="12" md="4" offset-md="0" class="pa-0">
              <v-list-item-title class="body-2">
                <v-icon small left>mdi-badge-account-horizontal-outline</v-icon>
                {{ cliente.cpf_cnpj }}
              </v-list-item-title>
            </v-col>
            <v-col cols="10" md="4" class="pa-0">
              <v-list-item-title class="body-2">
                <v-icon small left>mdi-phone</v-icon>
                {{ telefoneCliente(cliente.telefones) }}
              </v-list-item-title>
            </v-col>
            <v-divider
              :key="i"
              class="mt-2"
            ></v-divider>
          </v-list-item-content>
          <v-list-item-action class="ma-auto">
            <v-btn icon>
              <v-icon>mdi-arrow-right</v-icon>
            </v-btn>
          </v-list-item-action>
        </v-list-item>
      </v-list>
    </v-col>
    <v-col
      v-else
      v-for="(cliente, i) in computedClientes"
      :key="i"
      cols="12"
      md="4"
      class="py-0 pb-2"
      :class="{ 'px-1': $vuetify.breakpoint.mdAndUp }"
    >
      <CardCliente
        :cliente="cliente"
        @clicked="$router.push(`/clientes/${cliente.id_interno}`)"
      />
    </v-col>
    <v-col cols="12" class="pa-0" :class="listStyle === 'list' ? 'mt-1' : 'mb-1'" id="listClientesPagination">
      <v-pagination
        v-model="page"
        :length="totalPages"
        circle
        @input="scrollTop"
        @next="scrollTop"
        @previous="scrollTop"
      ></v-pagination>
    </v-col>
  </v-row>
  <v-col v-else cols="12" class="px-0">
    <p class="text-center font-weight-bold white py-3">Nenhum registro encontrado</p>
  </v-col>
</template>

<script>
import { mapGetters } from 'vuex';
import { convertStringToCompare } from '@/helpers';
import CardCliente from '@/components/shared/card/CardCliente';

export default {
  name: 'ListClientes',
  props: {
    filters: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    CardCliente
  },
  data: () => ({
    page: 1,
    listStyle: 'card'
  }),
  computed: {
    ...mapGetters(['clientes']),
    clientesContainer() {
      const offset = 80;
      const windowHeight = window.outerHeight;
      const paginationDiv = document.getElementById('listClientesPagination');
      const paginationHeight = paginationDiv ? paginationDiv.innerHeight : 44;
      const clientesContainerHeight = windowHeight - paginationHeight - offset;
      return {
        height: clientesContainerHeight.toString() + 'px',
        overflow: 'auto'
      }
    },
    computedClientes() {
      const start = (this.page - 1) * 10;
      const end = start + 10;
      let searchTerm = this.filters.search || '';
      searchTerm = convertStringToCompare(searchTerm);
      return this.clientes
        .filter(cliente => 
          convertStringToCompare(cliente.razao_social).includes(searchTerm || '') ||
          convertStringToCompare(cliente.nome_fantasia).includes(searchTerm || '') ||
          convertStringToCompare(cliente.cpf_cnpj).includes(searchTerm || '') ||
          convertStringToCompare(cliente.contato).includes(searchTerm || '')
        )
        .slice(start, end)
        .sort((a, b) => a[this.filters.order] > b[this.filters.order] ? 1 : -1);
    },
    totalPages() {
      const total = this.clientes.length / 10;
      return total !== Infinity ? Math.ceil(total) : 0;
    }
  },
  methods: {
    telefoneCliente(telefones) {
      if (telefones && telefones.length) {
        const primeiroTelefone = telefones[0];
        const message = `${primeiroTelefone.telefone} - ${primeiroTelefone.contato}`;
        return message;
      } else {
        return '';
      }
    },
    scrollTop() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      })
    }
  }
}
</script>

<style>

</style>